module.exports = __webpack_public_path__ + "img/1792485657351.c7d9ed95.png";